export default __webpack_public_path__ + "static/media/shareIcon.de328118.svg";